import { render, staticRenderFns } from "./player-matches-list.vue?vue&type=template&id=0528a894&"
import script from "./player-matches-list.vue?vue&type=script&lang=js&"
export * from "./player-matches-list.vue?vue&type=script&lang=js&"
import style0 from "./player-matches-list.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "player-matches-list.vue"
export default component.exports